import { defineStyleConfig } from "@chakra-ui/react";

export const Button = defineStyleConfig({
  baseStyle: {
    borderRadius: "full",
  },
  sizes: {
    sm: {
      fontSize: "sm",
      px: 6, // <-- these values are tokens from the design system
      py: 3, // <-- these values are tokens from the design system
    },
  },
  variants: {
    outline: {
      bg: "white",
      border: "1px solid",
      borderColor: "brand.900",
      color: "brand.900",
    },
    solid: {
      bg: "brand.900",
      color: "white",
    },
  },
  // The default size and variant values
  defaultProps: {
    size: "sm",
    variant: "solid",
    colorScheme: "brand",
  },
});
